import React from 'react';
import { Wallet, Clock, Award, Zap, Users, TrendingUp } from 'lucide-react';

const benefits = [
  {
    icon: <Wallet className="h-6 w-6" />,
    title: 'Great Earnings',
    description: 'Earn competitive rates with timely payments and incentives'
  },
  {
    icon: <Clock className="h-6 w-6" />,
    title: 'Flexible Hours',
    description: 'Choose your working hours and maintain work-life balance'
  },
  {
    icon: <Award className="h-6 w-6" />,
    title: 'Training & Support',
    description: 'Regular training sessions and technical support'
  },
  {
    icon: <Zap className="h-6 w-6" />,
    title: 'Regular Work',
    description: 'Steady flow of service requests in your area'
  },
  {
    icon: <Users className="h-6 w-6" />,
    title: 'Professional Network',
    description: 'Join a community of skilled technicians'
  },
  {
    icon: <TrendingUp className="h-6 w-6" />,
    title: 'Growth Opportunities',
    description: 'Career advancement and skill development paths'
  }
];

export default function PartnerBenefits() {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          Why Partner With Us?
        </h2>
        <p className="text-gray-600">
          Join our network of skilled technicians and enjoy numerous benefits while growing your career.
        </p>
      </div>

      <div className="grid gap-6">
        {benefits.map((benefit, index) => (
          <div
            key={index}
            className="flex items-start space-x-4 p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex-shrink-0 w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center text-blue-600">
              {benefit.icon}
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900">
                {benefit.title}
              </h3>
              <p className="mt-1 text-gray-600">
                {benefit.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}